import * as PropTypes from "prop-types"
import useFilteredOptions from "hooks/useFilteredOptions"
import { useT } from "react-polyglot-hooks"
import { useContext } from "react"
import { RentingContext } from "scenes/RentingScene/RentingContext"
import DropdownSelector from "../DropdownSelector"

export default function ProvinceSelector(props) {
  const { field } = props
  const t = useT()
  const { provinces } = useContext(RentingContext)
  const provinceOptions = provinces.map(p => ({ label: p, value: p }))

  const options = useFilteredOptions(field, provinceOptions)

  if (options.length === 0) return null

  return (
    <DropdownSelector
      options={options}
      placeholder={t("renting.filter.kind_placeholder")}
      multiple
      dynamic
      {...props}
    />
  )
}

ProvinceSelector.propTypes = {
  field: PropTypes.string.isRequired
}
